import { Component, inject } from '@angular/core';
import { AppState } from '@app/core/states/app.state';
import { UiModule } from '@app/ui';
import { environment } from '@env/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

@Component({
  selector: 'rk-ios-publishing-empty-state',
  imports: [TranslatePipe, UiModule],
  templateUrl: './ios-publishing-empty-state.component.html',
  styleUrl: './ios-publishing-empty-state.component.scss',
})
export class IosPublishingEmptyStateComponent {
  private readonly store = inject(Store);

  upgradeOffer(): void {
    const serviceId = this.store.selectSnapshot(AppState.currentAppServiceId);
    const currentAppId = this.store.selectSnapshot(AppState.currentAppId);

    if (serviceId === undefined || serviceId === null || serviceId === 0) {
      window.location.href = `/plan/${currentAppId}`;
    } else {
      window.location.href = `${environment.whmcs.url}/upgrade.php?type=package&id=${serviceId}`;
    }
  }
}
